import styled from "styled-components";
type Props = {
  imgType?: any;
};
export const QuoteApprovalModelHeader = styled.div`
  display: flex;
  flex-direction: column;
`;
export const MessageContent = styled.div`
  font-size: 14px;
  color: #6d7992;
  font-weight: 500;
  line-height: 1.65;
  margin: 12px 0;
  &.card-heading {
    font-weight: 700 !important;
    font-size: 16px !important;
    margin: 12px 0 8px !important;
  }
`;
export const FieldContainer = styled.div`
  width: 100%;
  margin: 8px 0;
`;
export const ModalBodyContainer = styled.div``;
export const CardModalBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const CloseButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
export const CloseIcon = styled.div`
  position: relative;
  right: 8px;
  top: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
  &:hover {
    background: #f2f7ff;
    cursor: pointer;
  }
  &.pointer_event {
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
export const UploadsDocmWrapper = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
`;
export const CardFieldContainer = styled.div`
  width: 70%;
  margin: 8px 0;
`;
export const CvvExpDateContainer = styled.div`
  display: flex;
  margin: 8px 0;
  justify-content: space-between;
  width: 70%;
  gap: 8px;
`;
export const CVVFieldContainer = styled.div`
  width: 90px;
`;
export const PaymentFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px 0 24px;
  > button {
    width: 65%;
  }
`;
export const QuoteSingleOptionContainer = styled.div`
  background: #fff0d7;
  padding: 4px 6px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  color: #a26a11;
`;
export const ImportFileFooter = styled.div`
  > div {
    padding: 20px 40px;
  }
  &.footer {
    display: flex;
    justify-content: flex-end;
  }
`;
export const UploadNote = styled.small`
  font-style: normal;
  font-weight: normal;
  line-height: 20px;

  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;

  margin: 0 0 8px;
  /* margin-top: 0; */
  color: #8e99b2;
  &.for-add-repair {
    justify-content: flex-start;
  }
  &.for-file-error-msg {
    color: red;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0;
    padding: 4px 4px;
  }
  &.for-item-range-notes {
    justify-content: flex-start;
  }
`;
export const H4Heading = styled.h4`
  color: var(--modelTitleColor);
  margin: 0px;
  margin-bottom: 8px;
`;
export const UploadWrapper = styled.div`
  .upload-container {
    border-radius: 4px;
    border: 2px dashed #bbdefb;
  }
`;
export const ImgUploadDiv = styled.div`
  width: 100px;
  height: 100px;
  background: #f5f7f7;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  border: 0.5px solid #f5f7f7;
  //h4{
  //  margin: 0;
  //  font-size: 16px;
  //  color: #68787A;
  // font-weight: 500;
  //}
  .css-s32gra {
    background: transparent;
    position: absolute;
    width: 160px;
    height: 160px;
    z-index: 99;
  }
  .upload-container {
    top: 0;
    border: 0;
    padding: 0;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    color: #68787a;
    outline: none;
    position: absolute;
    z-index: 999;
    cursor: pointer;
    height: 100%;
    width: 100%;
    svg {
      display: none;
    }
  }
  //.files-list li{
  //  padding: 6px;
  //  font-weight: 500;
  //  font-size: 12px;
  //  color: #68787A;
  //  display: none;
  //}
  .profile-pic-actions {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgb(30 80 142 / 50%);
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    p {
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      text-align: center;
      margin: 0;
    }
  }
  &:hover {
    .profile-pic-actions {
      opacity: 1;
      visibility: visible;
    }
  }

  .notes-cross-img {
    width: 14px;
    position: absolute;
    top: 0%;
    right: 0;
    height: 14px;
    cursor: pointer;
  }
`;

export const ProfilePicAvatar = styled.img`
  width: 90%;
  height: 90%;
  border-radius: 50px;
  ${({ imgType }: Props) => {
    if (imgType === "application/pdf") {
      return `border-radius:unset`;
    }
  }}
`;
export const NotesImgPreviewContainer = styled.div`
  padding: 2px 4px;
`;
export const UploadedDataContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 30px 1px;
`;
export const FileItemList = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
export const UploadedDefaultImg = styled.img`
  height: 24px;
  width: 18px;
`;
export const UploadFileName = styled.div`
  color: #2e374a;
  font-size: 12px;
  font-weight: 400;
  text-transform: capitalize;
`;
export const PreviewText = styled.div`
  color: #1976d2;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
export const UploadFileSize = styled.div`
  color: #000000b2;
  font-size: 12px;
  font-weight: 400;
`;
export const CloseIconRight = styled.div`
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
  }
`;
export const CardValidationMsg = styled.div`
  color: #f70505;
  overflow: hidden;
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 70%;
  &.register_form_validation {
    margin: 0 24px 12px;
  }
  &.open {
    &::before {
      content: "";
    }
  }
`;
